import { atom, useSetAtom, useAtomValue } from 'jotai';
import { getUnassignedStore, NeedToUpdateStore, getInvalidAccountNum } from 'services/api/admin';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

const invalidAccountState = atom<NeedToUpdateStore[]>([]);

export const useInvalidAccount = () => useAtomValue(invalidAccountState);

export const useSetInvalidAccount = () => {
  const { t } = useTranslate();
  const setInvalidAccount = useSetAtom(invalidAccountState);

  return () => {
    getInvalidAccountNum()
      .then((list) => {
        setInvalidAccount(list);
      })
      .catch(() => {
        message.error(t('api.invalidAccount'));
      });
  };
};

export type UnassignedStore = Store.Store;

const unassignedStoreListState = atom<UnassignedStore[]>([]);

export const useUnassignedStoreList = () => useAtomValue(unassignedStoreListState);

export const useSetUnassignedStoreList = () => {
  const { t } = useTranslate();
  const setUnassignedStoreList = useSetAtom(unassignedStoreListState);

  return () => {
    return getUnassignedStore()
      .then((list) => {
        setUnassignedStoreList(list);
        return list;
      })
      .catch(() => {
        message.error(t('api.invalidAccount'));
      });
  };
};
